import { render, staticRenderFns } from "./editShopType.vue?vue&type=template&id=4485923e"
import script from "./editShopType.vue?vue&type=script&lang=js"
export * from "./editShopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports